<template>
  <base-layout :do-skip-header="false" :doSkipPic="shouldSkipPic">
    <template #main>
      <Popover ref="popover_attendee" class=""></Popover>

      <div class="flex flex-col md:flex-row justify-between items-center md:items-start my-8">
        <h1 class="text-3xl md:text-4xl font-bold">Attendees of the 2026 EBM in Portugal</h1>
        <div v-if="!isTimeslotSelected()">
          <a :href="fileUrl" download="attendees.csv" ref="downloadLink" class="hidden">Download</a>
          <button @click="downloadCSV"
            class="mt-4 md:mt-0 rounded-md border border-transparent bg-red-700 py-2 px-4 text-lg sm:text-lg font-medium text-white shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 shadow-lg">Download
            attendee list</button>
        </div>
      </div>

      <div v-if="isTimeslotSelected()" class="mt-8">
        <span class="text-red-600"><strong>You are scheduling a meeting on {{ timeslotRequest.day === 1 ? "Thursday" :
          "Friday" }} from {{ timeslotRequest.timeStart }} - {{ timeslotRequest.timeEnd }}</strong></span><br />
        Please choose the company you would like to request your meeting with below.
      </div>

      <div v-if="user">
        <div class="sm:hidden mt-4">
          <label for="tabs" class="sr-only">Select view</label>
          <select v-model="currentTab"
            class="block w-full rounded-md border-gray-300 focus:border-red-500 focus:ring-red-500 text-sm">
            <option :key="0" :value="0">All Companies</option>
            <option :key="1" :value="1">Suggested By AI</option>
          </select>
        </div>
        <div class="hidden sm:block mt-4">
          <div class="border-b border-gray-200">
            <nav class="-mb-px flex space-x-8" aria-label="Tabs">
              <button :class="tabClass('0')" @click="currentTab = '0'">All Companies</button>
              <!-- <button :class="tabClass('1')" @click="currentTab = '1'" >Suggested By AI</button> -->

              <div class="relative group">
                <button :class="tabClass('1')" @click="currentTab = '1'">
                  Suggested By AI
                </button>

                <div
                  class="absolute left-1/2 top-full z-10 mt-2 hidden w-72 -translate-x-1/2 rounded bg-gray-800 px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                  These companies are recommended by AI based on your company profile and description.
                </div>
              </div>

            </nav>
          </div>
        </div>
      </div>

      <template v-if="!user || currentTab === '0'">
        <form @submit.self.prevent="doSearch" class="mt-6">
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12 sm:col-span-12 lg:col-span-7">
              <label for="cSearch" class="form-label block truncate">Search for Companies, Contact Persons or
                Specialty</label>
              <input v-model="qSearch" id="cSearch" class="form-input mt-1 block w-full" />
            </div>

            <div class="col-span-12 sm:col-span-6 lg:col-span-2">
              <label for="cPref" class="form-label block">Preference</label>
              <select v-model="qPref" id="cPref" class="form-select mt-1 block w-full">
                <option v-for="item in preferences" :value="item.id" :key="item.id">{{ item.value }}</option>
              </select>
            </div>

            <div class="col-span-12 sm:col-span-6 lg:col-span-2">
              <label for="cTradingType" class="form-label block">Trading Type</label>
              <select v-model="qTradingType" id="cTradingType" class="form-select mt-1 block w-full">
                <option v-for="item in tradingTypes" :value="item.id" :key="item.id">{{ item.value }}</option>
              </select>
            </div>

            <div class="col-span-12 sm:col-span-12 lg:col-span-1">
              <button @click="doSearch" type="button"
                class="btn btn-primary float-right lg:float-left lg:mt-6">Search</button>
            </div>
          </div>
        </form>

        <div v-if="attendees && attendees.length">
          <div class="mt-6 flex flex-col hidden lg:block">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th class="table-cell-header pr-0 pl-3"><!-- emblem gold/trusted --></th>
                      <th class="table-cell-header pl-1">Company Name</th>
                      <th class="table-cell-header">Country</th>
                      <th class="table-cell-header">Company Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in attendeesEnriched" :key="index"
                      @click="item.canNavigate ? navToAttendee(item.id, $event) : null"
                      class="bg-white transition duration-150 ease-in-out" :class="item.clazzContainer"
                      @mouseover="changePopoverData($event, item)" @mouseout="closePopoverData">
                      <td class="table-cell text-gray-900 pr-0 pl-3">
                        <div v-if="item.isDiamond" class="member_diamond"
                          title="This company is a 'Diamond Member'. Diamond members have been on www.EuropeanBrokerMeeting.com for 20 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                        <div v-if="item.isGold" class="member_gold"
                          title="This company is a 'Gold Member'. Gold members have been on www.EuropeanBrokerMeeting.com for 10 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                        <div v-if="item.isTrusted" class="member_trusted"
                          title="This company is a 'Trusted Member'. Trusted members have been on www.EuropeanBrokerMeeting.com for 3 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                      </td>
                      <td class="table-cell text-gray-900 pl-1">
                        <span class="inline-block font-semibold truncate hover-higlight max-w-48 align-middle"
                          :class="item.clazz">{{ item.name }}</span>
                      </td>
                      <td class="table-cell text-gray-500">{{ item.country }}</td>
                      <td class="table-cell text-gray-900">
                        <div class="max-w-144 truncate">{{ item.description }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="mt-12 flex flex-col block lg:hidden">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table class="w-full table-fixed">
                  <thead>
                    <tr>
                      <th class="table-cell-header pr-0 pl-3">Companies</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in attendeesEnriched" :key="index"
                      @click="item.canNavigate ? navToAttendee(item.id, $event) : null"
                      class="bg-white hover:bg-red-50 cursor-pointer transition duration-150 ease-in-out hover-higlight-anchor">
                      <td class="table-cell pr-0 pl-3 border-b-2 border-gray-200">
                        <div class="truncate">
                          <div v-if="item.isDiamond" class="float-left mr-2 member_diamond"
                            title="This company is a 'Diamond Member'. Diamond members have been on www.EuropeanBrokerMeeting.com for 20 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <div v-if="item.isGold" class="float-left mr-2 member_gold"
                            title="This company is a 'Gold Member'. Gold members have been on www.EuropeanBrokerMeeting.com for 10 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <div v-if="item.isTrusted" class="float-left mr-2 member_trusted"
                            title="This company is a 'Trusted Member'. Trusted members have been on www.EuropeanBrokerMeeting.com for 3 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <span class="text-gray-900 hover-higlight font-semibold text-base" :class="item.clazz">{{
                            item.name }}</span>
                        </div>
                        <div class="truncate mr-2">{{ item.description }}</div>
                        <div class="truncate text-gray-500">{{ item.country }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="attendees && !attendees.length" class="text-sm leading-5 text-gray-700 font-bold mt-4">No
          results found for this query. Please broaden your search.</div>
      </template>

      <div v-if="user && currentTab === '1'">
        <div v-if="suggestedAttendees === null" class="text-sm leading-5 text-gray-700 font-bold mt-4">Loading
          suggestions...
        </div>
        <div v-else-if="!suggestedAttendees.length" class="text-sm leading-5 text-gray-700 font-bold mt-4">No suggestions available. Please update your company details or try again later.</div>
        <template v-else>
          <div class="mt-4 flex flex-col hidden lg:block">
            <div class="mb-4 flex items-start rounded-lg bg-blue-50 p-4 border border-blue-200">
              <span class="mr-3 text-2xl">💡</span>
              <div>
                <p class="text-sm text-blue-800 mt-1.5">
                  These companies are recommended by AI based on your company profile and description
                </p>
              </div>
            </div>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th class="table-cell-header pr-0 pl-3">Match</th>
                      <th class="table-cell-header pr-0 pl-3"><!-- emblem gold/trusted --></th>
                      <th class="table-cell-header pl-1">Company Name</th>
                      <th class="table-cell-header">Country</th>
                      <th class="table-cell-header">Company Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in suggestedAttendeesEnriched" :key="index"
                      @click="item.canNavigate ? navToAttendee(item.id, $event) : null"
                      class="bg-white transition duration-150 ease-in-out" :class="item.clazzContainer"
                      @mouseover="changePopoverData($event, item)" @mouseout="closePopoverData">
                      <td class="table-cell pr-0 pl-3">
                        <span class="text-gray-500">{{ Math.round(item.similarity * 100) }}%</span>
                      </td>
                      <td class="table-cell text-gray-900 pr-0 pl-3">
                        <div v-if="item.isDiamond" class="member_diamond"
                          title="This company is a 'Diamond Member'. Diamond members have been on www.EuropeanBrokerMeeting.com for 20 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                        <div v-if="item.isGold" class="member_gold"
                          title="This company is a 'Gold Member'. Gold members have been on www.EuropeanBrokerMeeting.com for 10 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                        <div v-if="item.isTrusted" class="member_trusted"
                          title="This company is a 'Trusted Member'. Trusted members have been on www.EuropeanBrokerMeeting.com for 3 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                        </div>
                      </td>
                      <td class="table-cell text-gray-900 pl-1">
                        <span class="inline-block font-semibold truncate hover-higlight max-w-48 align-middle"
                          :class="item.clazz">{{ item.name }}</span>
                      </td>
                      <td class="table-cell text-gray-500">{{ item.country }}</td>
                      <td class="table-cell text-gray-900">
                        <div class="max-w-144 truncate">{{ item.description }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="mt-6 flex flex-col block lg:hidden">
            <div class="mb-6 flex items-start rounded-lg bg-blue-50 p-4 border border-blue-200">
              <span class="mr-3 text-2xl">💡</span>
              <div>
                <p class="text-sm text-blue-800">
                  These companies are recommended by AI based on your company profile and description
                </p>
              </div>
            </div>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table class="w-full table-fixed">
                  <thead>
                    <tr>
                      <th class="table-cell-header pr-0 pl-3">Companies</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in suggestedAttendeesEnriched" :key="index"
                      @click="item.canNavigate ? navToAttendee(item.id, $event) : null"
                      class="bg-white hover:bg-red-50 cursor-pointer transition duration-150 ease-in-out hover-higlight-anchor">
                      <td class="table-cell pr-0 pl-3 border-b-2 border-gray-200">
                        <div class="truncate">
                          <div v-if="item.isDiamond" class="float-left mr-2 member_diamond"
                            title="This company is a 'Diamond Member'. Diamond members have been on www.EuropeanBrokerMeeting.com for 20 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <div v-if="item.isGold" class="float-left mr-2 member_gold"
                            title="This company is a 'Gold Member'. Gold members have been on www.EuropeanBrokerMeeting.com for 10 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <div v-if="item.isTrusted" class="float-left mr-2 member_trusted"
                            title="This company is a 'Trusted Member'. Trusted members have been on www.EuropeanBrokerMeeting.com for 3 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.">
                          </div>
                          <span class="text-gray-900 hover-higlight font-semibold text-base" :class="item.clazz">{{
                            item.name }}</span>
                        </div>
                        <div class="mt-1 mb-1 text-xs text-gray-500">{{ Math.round(item.similarity * 100) }}% match
                        </div>
                        <div class="truncate mr-2">{{ item.description }}</div>
                        <div class="truncate text-gray-500">{{ item.country }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </base-layout>
</template>

<script>
import _ from "lodash"
import { mapState } from "vuex"

import BaseLayout from "../components/BaseLayout.vue"
import Popover from "../components/Popover.vue"

export default {
  name: "Register",
  components: {
    BaseLayout,
    Popover,
  },
  data() {
    return {
      attendees: null,
      qSearch: "",
      qPref: "",
      qTradingType: "",
      preferences: [
        { id: "", value: "None" },
        { id: 1, value: "PC/Laptops" },
        { id: 2, value: "Printers" },
        { id: 3, value: "Server/Storage" },
        { id: 4, value: "Networking/Telecom" },
        { id: 5, value: "Software" },
        { id: 6, value: "Electronics" },
        { id: 7, value: "Mobile" },
        { id: 8, value: "POS/BarCode/Banking" },
        { id: 9, value: "Components" },
      ],
      tradingTypes: [
        { id: "", value: "None" },
        { id: "new equipment", value: "New" },
        { id: "used equipment", value: "Used" },
      ],
      fileUrl: "",
      shouldSkipPic: false,
      currentTab: "0",
      suggestedAttendees: null,
    }
  },
  computed: {
    ...mapState(["user", "timeslotRequest"]),
    attendeesEnriched() {
      return this.enrichAttendees(this.attendees)
    },
    suggestedAttendeesEnriched() {
      return this.enrichAttendees(this.suggestedAttendees)
    },
  },
  async mounted() {
    this.shouldSkipPic = !!this.user
    // TO DO: we need to check if a timeslotId is given and if so, we will not include any companies that do not have contacts with that available timeslot
    await this.doSearch()
    if (this.user) await this.fetchSuggested()
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        // reset the timeslot object if the user didn't come from the scheduler or the company details
        if (this.$store.state.route.from.name != "scheduler" && this.$store.state.route.from.name != "companyDetail") {
          this.$store.dispatch("updateTimeslotRequest", [])
        }
        // else {
        //     const timeslotRequest = JSON.parse(localStorage.getItem('timeslotRequest'))
        //     this.$store.dispatch('updateTimeslotRequest', timeslotRequest)
        //     localStorage.removeItem("timeslotRequest")
        // }
      },
    },
  },

  methods: {
    enrichAttendees(list) {
      if (!list) return []
      return _.map(list, att => ({
        ...att,
        clazzContainer: this.user && att.status === 3 ? "cursor-pointer  hover:bg-red-50 hover-higlight-anchor" : "",
        clazz: att.status === 3 ? "text-red-700 " : "",
        canNavigate: this.user && att.status === 3,
        memberAsText: att.isDiamond ? "TBS Diamond Member" : att.isGold ? "TBS Gold Member" : att.isTrusted ? "TBS Trusted Member" : "TBS Regular Member",
      }))
    },
    async fetchSuggested() {
      const { data } = await this.$http.get(`/api/companies/suggested/${this.user.companyId}`)
      const suggestions = data?.payload?.suggestions ?? []
      const scoreMap = new Map(suggestions.map(s => [s.companyId, s.similarity]))
      const matched = this.attendees.filter(att => scoreMap.has(att.id)).map(att => ({ ...att, similarity: scoreMap.get(att.id) }))
      matched.sort((a, b) => b.similarity - a.similarity)
      this.suggestedAttendees = matched
    },
    tabClass(index) {
      this.currentTab = String(this.currentTab)
      if (+index === +this.currentTab) return "border-red-500 text-red-600 flex whitespace-nowrap border-b-2 py-4 px-1 font-medium"
      return "border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700 flex whitespace-nowrap border-b-2 py-4 px-1 font-medium"
    },
    changePopoverData(event, item) {
      if (item.status !== 3) return
      this.$refs.popover_attendee.changeData(event.currentTarget, item)
    },
    closePopoverData() {
      this.$refs.popover_attendee.close()
    },
    async doSearch() {
      const payload = {
        search: this.qSearch.trim() || null,
        pref: this.qPref || null,
        tradingType: this.qTradingType || null,
      }
      this.attendees = await this.$http.post("/api/misc/attendees", payload).then(res => res.data.payload)
    },
    async downloadCSV() {
      const response = await this.$http({
        url: "/api/misc/attendeesAsCSV",
        method: "GET",
        responseType: "blob",
      })
      this.fileUrl = window.URL.createObjectURL(new Blob([response.data]))
      this.$nextTick(() => this.$refs.downloadLink.click())
    },
    navToAttendee(id, event) {
      // if (event.ctrlKey || event.metaKey) return window.open(this.$router.resolve({ name: 'companyDetail', params: { id } }).href, '_blank');
      // this.$router.push({ name: 'companyDetail', params: { id } })
      const state_timeslot = this.$store.getters.getTimeslotRequest
      localStorage.setItem("tsRequest", JSON.stringify(state_timeslot))

      const url = this.$router.resolve({ name: "companyDetail", params: { id: id } }).href
      window.open(url, "_blank")
    },
    isTimeslotSelected() {
      return !!this.timeslotRequest.id && (this.$store.state.route.from.name === "scheduler" || this.$store.state.route.from.name === "companyDetail")
    },
  },
}
</script>
<style scoped>
.member_trusted {
  width: 24px;
  height: 24px;
  background: url("../assets/trusted_small.png");
  background-size: cover;
}

.member_gold {
  width: 24px;
  height: 24px;
  background: url("../assets/gold_small.png");
  background-size: cover;
}

.member_diamond {
  width: 24px;
  height: 24px;
  background: url("../assets/member_diamond.png");
  background-size: cover;
}

.excel_icon {
  width: 24px;
  height: 24px;
  background: url("../assets/excel.png");
  background-size: cover;
}
</style>
```